import { Outlet } from 'react-router';
import Navbar from './Navbar.jsx';

export default function Layout() {
  return (
    <>
      <Navbar />
      <main style={{ paddingTop: '72px' }}>
        <Outlet />
      </main>
    </>
  );
}
